import { useEffect, useState } from 'react';
import axios from 'axios';
import { LicUpdateCreate } from './Components/ModalLicense';
import { getLicenceList, getLicenseListglobal } from './request/request';
import { useAppSelector } from '../../../../redux/hooks';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import Swal from 'sweetalert2';
import ModalSwal from '../../permisoDenegado/Modalswal';
import styles from './licenseTable.module.scss';
import { useAuth } from '../../auth';
import React from 'react';

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

function LicenseCrud() {
    const { currentUser } = useAuth()
    const tenant = useAppSelector(state => state.TenantSlice.id)
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
    const Type = useAppSelector(state => state.CloudSlice.Type)

    const [ID, setID] = useState<ID>(undefined)
    const [records, setRecords] = useState<any | null>([])
    const [highlightedId, setHighlightedId] = useState<string | null>(null)

    const MostrarModal = (!ListaPermisosTenant.includes('CTXR.License'))

    // Estados para búsqueda y paginación
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    // Estado para seleccionar la columna a buscar
    const [searchColumn, setSearchColumn] = useState('All');

    // Estados para ordenar columnas
    const [sortColumn, setSortColumn] = useState<string>('');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

    function applySearch(data: any[]) {
        if (!searchTerm) return data;

        const lowerTerm = searchTerm.toLowerCase();

        return data.filter((d: any) => {
            if (searchColumn === 'All') {
                return (
                    d.tenant?.toLowerCase().includes(lowerTerm) ||
                    d.subscription?.toLowerCase().includes(lowerTerm) ||
                    d.startdate?.toLowerCase().includes(lowerTerm) ||
                    d.enddate?.toLowerCase().includes(lowerTerm) ||
                    d.serial?.toLowerCase().includes(lowerTerm) ||
                    d.type?.toLowerCase().includes(lowerTerm) ||
                    d.description?.toLowerCase().includes(lowerTerm)
                );
            } else {
                const val = d[searchColumn]?.toString().toLowerCase() || '';
                return val.includes(lowerTerm);
            }
        });
    }

    function applySort(data: any[]) {
        if (!sortColumn) return data;
        const sorted = [...data].sort((a, b) => {
            const valA = a[sortColumn]?.toString().toLowerCase() || '';
            const valB = b[sortColumn]?.toString().toLowerCase() || '';
            if (valA < valB) return sortDirection === 'asc' ? -1 : 1;
            if (valA > valB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
        return sorted;
    }

    const filteredData = applySearch(records || []);
    const sortedData = applySort(filteredData);

    // Paginación
    const totalItems = sortedData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = sortedData.slice(startIndex, endIndex);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    useEffect(() => {
        if (currentUser?.ListPermiso?.includes('CTXR.License')) {
            if (tenant === 0 && Id !== 0 && Type !== 'Global') {
                getLicenceList(Id).then(response => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Type !== 'Global') {
                getLicenseListglobal(Id, tenant).then(response => {
                    setRecords(response.data)
                })
            }
        }
    }, [Id, currentUser, tenant, Type])

    useEffect(() => {
        if (currentUser?.ListPermiso?.includes('CTXR.License')) {
            if (tenant === 0 && Id === 0 && Type === 'Global') {
                getLicenceList(-1).then(response => {
                    setRecords(response.data)
                })
            }
            else if (tenant !== 0 && Id === 0 && Type === 'Global') {
                getLicenseListglobal(-1, tenant).then(response => {
                    setRecords(response.data)
                })
            }
        }
    }, [Type, Id, currentUser, tenant])

    useEffect(() => {
        if (Type) {
            setRecords([])
        }
    }, [Type])

    function reloaddevice() {
        if (Id !== 0 && Type !== 'Global') {
            if (tenant === 0) {
                getLicenceList(Id).then(response => {
                    setRecords(response.data)
                })
            }
            else if (tenant !== 0) {
                getLicenseListglobal(Id, tenant).then(response => {
                    setRecords(response.data)
                })
            }
        }
        if (Id === 0 && Type === 'Global') {
            if (tenant === 0) {
                getLicenceList(-1).then(response => {
                    setRecords(response.data)
                })
            }
            else if (tenant !== 0) {
                getLicenseListglobal(-1, tenant).then(response => {
                    setRecords(response.data)
                })
            }
        }
    }

    function formatDate(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();
        return `${day}-${month}-${year}`;
    }

    const [expandedRows, setExpandedRows] = useState<number[]>([]);
    const [devicesByRow, setDevicesByRow] = useState<{ [key: number]: any[] }>({});

    const toggleRowExpansion = (index: number, id: any) => {
        if (expandedRows.includes(index)) {
            setDevicesByRow((prevDevicesByRow) => {
                const updatedDevicesByRow = { ...prevDevicesByRow };
                delete updatedDevicesByRow[index];
                return updatedDevicesByRow;
            });
            setExpandedRows(expandedRows.filter((rowIndex) => rowIndex !== index));
        } else {
            let url = '';
            if (tenant === 0 && Type !== 'Global') {
                url = API_URL + '/v1/ctxr/' + Id + '/listbylicence/' + id;
            } else if (tenant !== 0 && Type !== 'Global') {
                url = API_URL + '/v1/ctxr/' + Id + '/listbylicence/' + id + '?tenantId=' + tenant;
            } else if (tenant === 0 && Type === 'Global') {
                url = API_URL + '/v1/ctxr/' + -1 + '/listbylicence/' + id;
            } else if (tenant !== 0 && Type === 'Global') {
                url = API_URL + '/v1/ctxr/' + -1 + '/listbylicence/' + id + '?tenantId=' + tenant;
            }

            axios.get(url)
                .then(res => {
                    setDevicesByRow((prevDevicesByRow) => ({
                        ...prevDevicesByRow,
                        [index]: res.data
                    }));
                    setExpandedRows([...expandedRows, index]);
                })
        }
    };

    function handleSubmit(id: any) {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this License!",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let url = '';
                    if (tenant === 0 && Type !== 'Global') {
                        url = API_URL + '/v1/CTX-R/' + Id + '/' + id;
                    } else if (tenant !== 0 && Type !== 'Global') {
                        url = API_URL + '/v1/CTX-R/' + Id + '/' + id + '?tenantId=' + tenant;
                    } else if (tenant === 0 && Type === 'Global') {
                        url = API_URL + '/v1/CTX-R/' + -1 + '/' + id;
                    } else if (tenant !== 0 && Type === 'Global') {
                        url = API_URL + '/v1/CTX-R/' + -1 + '/' + id + '?tenantId=' + tenant;
                    }

                    axios.delete(url)
                        .then(res => {
                            if (res.data.error) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The license cannot be removed because it is activated.'
                                });
                            }
                            else {
                                Swal.fire(
                                    'Deleted!',
                                    'Your License has been deleted.',
                                    'success'
                                );
                            }

                            if (tenant === 0 && Type !== 'Global') {
                                getLicenceList(Id).then(response => {
                                    setRecords(response.data)
                                })
                            } else if (tenant !== 0 && Type !== 'Global') {
                                getLicenseListglobal(Id, tenant).then(response => {
                                    setRecords(response.data)
                                })
                            } else if (tenant === 0 && Type === 'Global') {
                                getLicenceList(-1).then(response => {
                                    setRecords(response.data)
                                })
                            } else if (tenant !== 0 && Type === 'Global') {
                                getLicenseListglobal(-1, tenant).then(response => {
                                    setRecords(response.data)
                                })
                            }
                        })
                } else {
                    Swal.fire({ title: "Your License is safe!", icon: "success" });
                }
            });
    }

    // Iconos para sort:
    const getSortIcon = (col: string) => {
        if (sortColumn === col) {
            return sortDirection === 'asc'
                ? <KeyboardArrowUpIcon className={styles['sort-icon']} />
                : <KeyboardArrowDownIcon className={styles['sort-icon']} />;
        } else {
            // Mostrar un ícono neutro indicando que la columna se puede ordenar
            return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />;
        }
    };

    return (
        <>
            <ModalSwal show={MostrarModal}></ModalSwal>
            <div className='card'>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column '>
                        <span className='f-titulo text-marino fs-md'>License Management Super Admin</span>
                    </h3>
                    <div className="d-flex align-items-center" style={{ marginRight: '1.5rem' }}>
                        {<button onClick={() => setID(null)} className='btn-light-marino f-parrafo'> Add License</button>}
                        <button className="btn-light-marino f-parrafo" style={{ marginLeft: '10px' }} onClick={reloaddevice}>
                            <i className="text-gray-100 bi bi-arrow-clockwise"></i>
                        </button>
                    </div>
                </div>
                {/* end::Header */}

                {/* begin::Body */}
                <div className='card-body ' style={{ overflowX: 'auto', margin: '10px', minHeight: '65vh' }}>
                    <div className='tab-content'>

                        {/* Barra de búsqueda y conteo de registros */}
                        {(records && records.length > 0) && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', marginRight: '5px' }}>

                                <div>
                                    <span className="text-marino f-parrafo fw-semibold">
                                        Total Records: {totalItems}
                                    </span>
                                </div>

                                {/* AQUÍ UNIFICAMOS LUPA, SELECT Y INPUT EN UN SOLO INPUT-GROUP */}
                                <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                                    <div
                                        className="input-group custom-search-group"
                                        style={{ width: '400px', display: 'flex', height: '30px' }}
                                    >
                                        <span
                                            className="input-group-text"
                                            style={{
                                                justifyContent: 'center',
                                                height: '30px',
                                                lineHeight: '30px',
                                                padding: '0 8px'
                                            }}
                                        >
                                            <i
                                                className="bi-search"
                                                style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                                            ></i>
                                        </span>
                                        <select
                                            className="form-select"
                                            style={{
                                                border: '1px solid var(--bs-gray-300)',
                                                width: '130px',
                                                height: '30px',
                                                lineHeight: '30px',
                                                padding: '0 8px',
                                                fontSize: '0.875rem'
                                            }}
                                            value={searchColumn}
                                            onChange={(e) => { setSearchColumn(e.target.value); setCurrentPage(1); }}
                                        >
                                            <option value="All">All</option>
                                            <option value="tenant">Tenant</option>
                                            <option value="subscription">Subscription</option>
                                            <option value="startdate">Start Date</option>
                                            <option value="enddate">End Date</option>
                                            <option value="serial">License</option>
                                            <option value="type">Type</option>
                                            <option value="description">Description</option>
                                        </select>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{
                                                width: '200px',
                                                height: '30px',
                                                lineHeight: '30px',
                                                padding: '0 8px',
                                                fontSize: '0.875rem'
                                            }}
                                            placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn}`}
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* begin::Table container */}
                        <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>

                            {/* begin::Table */}
                            <table className='w-full f-parrafo caption-bottom custom-table' id='table'>
                                {/* begin::Table head */}
                                <thead>
                                    <tr className='text-azul'>
                                        <th className='table-cell' onClick={() => handleSort('tenant')}>
                                            <div className={styles['header-content']}>
                                            <span>Tenant</span>
                                            <span className={styles['sortable-column']}>
                                                 {getSortIcon('tenant')}
                                            </span>
                                            </div>
                                            
                                        </th>
                                        <th className='table-cell' onClick={() => handleSort('subscription')}>
                                            <div className={styles['header-content']}>
                                                <span>Subscription</span>
                                            <span className={styles['sortable-column']}>
                                                 {getSortIcon('subscription')}
                                            </span>
                                            </div>
                                            
                                        </th>
                                        <th className='table-cell' onClick={() => handleSort('startdate')}>
                                            <div className={styles['header-content']} >
                                                <span>Start Date</span>
                                            <span className={styles['sortable-column']}>
                                                  {getSortIcon('startdate')}
                                            </span>
                                            </div>
                                        </th>
                                        <th className='table-cell' onClick={() => handleSort('enddate')}>
                                            <div className={styles['header-content']}  >
                                                <span>End Date</span>
                                            <span className={styles['sortable-column']}>
                                            {getSortIcon('enddate')}
                                            </span>
                                            </div>
                                            
                                        </th>
                                        <th className='table-cell' onClick={() => handleSort('serial')}>
                                            <div className={styles['header-content']}  >
                                                <span>License</span>
                                            <span className={styles['sortable-column']}>
                                                {getSortIcon('serial')}
                                            </span>
                                            </div>
                                            
                                        </th>
                                        <th className='table-cell' onClick={() => handleSort('type')}>
                                            <div className={styles['header-content']}  >
                                                <span>Type</span>
                                            <span className={styles['sortable-column']}>
                                                 {getSortIcon('type')}
                                            </span>
                                            </div>
                                        </th>
                                        <th className='table-cell w-150px' onClick={() => handleSort('description')}>
                                            <div className={styles['header-content']}  >
                                                <span>Description</span>
                                            <span className={styles['sortable-column']}>
                                                {getSortIcon('description')}
                                            </span>
                                            </div>
                                        </th>
                                        <th className='table-cell'>Activations</th>
                                        <th className='table-cell' style={{ width: '220px' }}>Actions</th>
                                    </tr>
                                </thead>
                                {/* end::Table head */}

                                {/* begin::Table body */}
                                <tbody>
                                    {paginatedData?.length === 0 ? (
                                        <tr>
                                            <td colSpan={10} className="text-center">
                                                <span className='text-pink fw-bold fs-p'>No Data Available</span>
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedData?.map((d: any, i: any) => (
                                            <React.Fragment key={i}>
                                                <tr
                                                    className={`table-row ${d.serial === highlightedId ? styles['highlighted-row'] : ''}`}
                                                >
                                                    <td className='table-cell'>{d.tenant}</td>
                                                    <td className='table-cell'>{d.subscription}</td>
                                                    <td className='table-cell'>{formatDate(d.startdate)}</td>
                                                    <td className='table-cell '>{formatDate(d.enddate)}</td>
                                                    <td className='table-cell '>{d.serial}</td>
                                                    <td className='table-cell '>{d.type}</td>
                                                    <td className='table-cell'>{d.description}</td>
                                                    <td className='table-cell'>{d.activated} of {d.total}</td>

                                                    <td className='table-cell' style={{ display: 'flex', justifyContent: 'center', width: '220px' }}>
                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                            <button className='btn btn-primary text-center' onClick={() => (toggleRowExpansion(i, d.id))}>
                                                                {expandedRows.includes(i) ? 'Close' : 'Devices'}
                                                            </button>
                                                            <div className="btn-group" role="group">
                                                                <button type="button" className="btn-light-marino dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    Actions
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    <li>
                                                                        {currentUser?.ListPermiso?.includes('CTXR.License') && (
                                                                            <button
                                                                                className={`dropdown-item ${styles['dropdown-item-edit']} text-start`}
                                                                                onClick={() => setID(d.id)}
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                        )}
                                                                    </li>
                                                                    <li>
                                                                        {currentUser?.ListPermiso?.includes('CTXR.License') && (
                                                                            <button
                                                                                className={`dropdown-item ${styles['dropdown-item-delete']} text-start`}
                                                                                onClick={e => handleSubmit(d.id)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        )}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                {expandedRows.includes(i) && (
                                                    <tr key={`details-${i}`} className="expanded-details">
                                                        <td colSpan={10}>
                                                            <div className="d-flex flex-center" style={{ marginLeft: '30px', marginTop: '10px', marginBottom: '15px' }}>
                                                                {devicesByRow[i] && devicesByRow[i].length !== 0 ? (
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th className='table-cell'>Name</th>
                                                                                <th className='table-cell'>Description</th>
                                                                                <th className='table-cell'>ID</th>
                                                                                <th className='table-cell'>Cloud</th>
                                                                                <th className='table-cell'>Region</th>
                                                                                <th className='table-cell'>Activated</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {devicesByRow[i].map((x: any, j: any) => (
                                                                                <tr key={j}>
                                                                                    <td className='table-cell'>{x.name}</td>
                                                                                    <td className='table-cell'>{x.description}</td>
                                                                                    <td className='table-cell'>{x.id}</td>
                                                                                    <td className='table-cell'>{x.cloud}</td>
                                                                                    <td className='table-cell'>{x.region}</td>
                                                                                    <td className='table-cell'>{formatDate(x.activated)}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                ) : (
                                                                    <div>
                                                                        <span className='text-pink fw-bold fs-p'>No Devices Available</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))
                                    )}
                                </tbody>
                                {/* end::Table body */}
                            </table>
                            {/* end::Table */}

                            {/* Paginación */}
                            {filteredData.length > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                                    <div>
                                        {currentPage > 1 && (
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                className="btn btn-secondary"
                                            >
                                                Previous
                                            </button>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {currentPage < totalPages && (
                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                className="btn btn-secondary"
                                            >
                                                Next
                                            </button>
                                        )}

                                        <div className="select-container" style={{ width: '120px' }}>
                                            <select className="custom-select aligned-select text-center"
                                                aria-label="Select items per page"
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}>
                                                <option value={5}>5 rows</option>
                                                <option value={10}>10 rows</option>
                                                <option value={20}>20 rows</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <br />
                    </div>
                </div>
            </div>
            {ID !== undefined && (
                <LicUpdateCreate
                    setID={setID}
                    id={ID}
                    setRecords={setRecords}
                    setHighlightedId={setHighlightedId}
                />
            )}
        </>
    );
}

export default LicenseCrud;
